import { render, staticRenderFns } from "./DatePick.vue?vue&type=template&id=6bed23a6&scoped=true"
import script from "./DatePick.vue?vue&type=script&lang=js"
export * from "./DatePick.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bed23a6",
  null
  
)

export default component.exports